export type CreateOperatorStatusErrorCode = 'PERMISSION_DENIED' | 'MISSING_ARGUMENT' | 'NAME_ALREADY_EXISTS' | 'UNKNOWN';

export class CreateOperatorStatusError extends Error {
    code: CreateOperatorStatusErrorCode;

    constructor(code: CreateOperatorStatusErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
